'use strict'
import CommonDialogUtils from "./CommonDialogUtils.js";
import HtmlUtils from "../../../components/HtmlUtils.js";

export default class ImportVisualizationsDialog {
    constructor() {
        this._dialog = null;
        this._callbacks = [];
    }

    /**
     * @param {string} eventName
     * @param {function} callback
     */
    on(eventName, callback){
        this._callbacks[eventName] = callback;
    }

    /**
     * @returns {ImportVisualizationsDialog}
     */
    render() {
        if (this._dialog)
            this._dialog.remove();
        CommonDialogUtils.fixPageScroll();
        this._dialog = this._createModal(ImportVisualizationsDialog._htmlTemplate());

        let closeBtn = this._dialog.querySelector('.btn-cancel');
        closeBtn.addEventListener('click', ()=>{
            this.remove();
        })

        this._dialog.addEventListener('keydown', (evt) => {
            evt.stopPropagation();
            if (evt.repeat) return;
            switch (evt.key) {
                case 'Escape' :{
                    closeBtn.dispatchEvent(new Event('click'))
                    break;
                }
                case 'Enter' : {
                    break;
                }
            }
        })
        const batchNameInput = this._dialog.querySelector('#batch-name');
        let timer= null;
        batchNameInput.addEventListener('input', () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(async () => {
                if (this._callbacks['batch-name-change'])
                    await this._callbacks['batch-name-change'](batchNameInput.value);
                timer = null;
            }, 500);
        });

        const list = this._dialog.querySelector('.md-list');
        let timer2= null;

        list.addEventListener('scroll', () => {
            if (list.scrollHeight - list.getBoundingClientRect().height - list.scrollTop < 150){
                if (timer2) clearTimeout(timer2);
                timer2 = setTimeout(async () => {
                    if (this._callbacks['batch-list-next-page'])
                        await this._callbacks['batch-list-next-page'](batchNameInput.value);
                    timer2 = null;
                }, 150);
            }
        })

        setTimeout(()=>{
            this._dialog.focus();
        }, 150);

        return this;
    }

    setBatchList(data) {
        this._dialog.querySelector('.md-list').replaceChildren();
        this.appendBatchList(data);
    }

    appendBatchList(data) {
        let list = this._dialog.querySelector('.md-list');
        for (const datum of data) {
            let li = this._createLi(datum);
            list.appendChild(li);
            list.lastChild.addEventListener('click', async () => {
                let progressBar = this._dialog.querySelector('.progress');
                progressBar.style.display = 'block';
                await this.#onBatchSelected(datum);
            })
        }
    }

    /**
     * @param {BatchListEntry} datum
     */
    _createLi(datum) {
        let tmpl = document.createElement('template');
        tmpl.innerHTML = `<li class="md-list-item" data-id="${datum.getId()}"> 
                                    <div class="md-list-item-content">
                                      <span class="md-list-item__text"></span>
                                    </div>
                                  </li>`
        let fragment = tmpl.content;
        fragment.querySelector('span').textContent = datum.getDisplayName();
        return fragment;
    }

    remove() {
        CommonDialogUtils.releasePageScroll();
        this._dialog.remove();
    }

    _createModal(node) {
        return HtmlUtils.createModal(node);
    }
    async #onBatchSelected(datum){
        try {
            if (this._callbacks['batch-selected'])
                await this._callbacks['batch-selected'](datum);
        } finally {
            const progressBar = this._dialog.querySelector('.progress');
            progressBar && (progressBar.style.display = 'none');
        }
    }

    /**
     * @returns {Node}
     * @private
     */
    static _htmlTemplate() {
        let tmpl = document.createElement('template');
        tmpl.innerHTML = `
            <div id="import-visualizations-dialog" class="dialog">
              <div class="progress">
                <div class="indeterminate"></div>
              </div>
              <div class="dialog-content">
                <text-input id="batch-name" label="Batch name"></text-input>
                <ul class="md-list"></ul>
              </div>
              <div class="dialog-buttons-row">
                <button class="button button--text btn-cancel">Close</button>
              </div>
            </div>`
        ;
        return tmpl.content.cloneNode(true);
    }
}
